export enum TermsTypeEnum {
  TERM_CONFIDENTIALITY_CONSENT = 'TERM_CONFIDENTIALITY_CONSENT',
  TERM_CONFIDENTIALITY = 'TERM_CONFIDENTIALITY',
  TERM_CONFIDENTIALITY_AND_DATA_PROTECTION = 'TERM_CONFIDENTIALITY_AND_DATA_PROTECTION',
  TERM_CONFIDENTIALITY_AND_DATA_PROTECTION_2024 = 'TERM_CONFIDENTIALITY_AND_DATA_PROTECTION_2024',
  TERM_USE_HOSPITAL_EQUIPMENT = 'TERM_USE_HOSPITAL_EQUIPMENT',
  TERM_ACCEPTANCE_COMPLIANCE = 'TERM_ACCEPTANCE_COMPLIANCE',
  TERM_REGISTRATION_AND_CONFIDENTIALITY__OF_THE_RECORDS_AND_PORTAL_LABORATORY_TESTS_AND_DIAGNOSES = 'TERM_REGISTRATION_AND_CONFIDENTIALITY__OF_THE_RECORDS_AND_PORTAL_LABORATORY_TESTS_AND_DIAGNOSES'
}
